import { ADVICE_REQUESTS_ENDPOINT } from 'common/constants'
import { request } from 'common/utils'

import query from '../graphql/matchChancelleries.graphql'
import { MatchChancelleriesQuery, MatchChancelleriesQueryVariables } from '../interfaces'

export const matchChancelleries = async (variables: MatchChancelleriesQueryVariables): Promise<MatchChancelleriesQuery> =>
  request<MatchChancelleriesQuery, MatchChancelleriesQueryVariables>(ADVICE_REQUESTS_ENDPOINT, query, variables)
